import { render, staticRenderFns } from "./billingData.vue?vue&type=template&id=15f6e0a2&scoped=true"
import script from "./billingData.vue?vue&type=script&lang=js"
export * from "./billingData.vue?vue&type=script&lang=js"
import style0 from "./billingData.vue?vue&type=style&index=0&id=15f6e0a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f6e0a2",
  null
  
)

export default component.exports